<template>
  <layout-basic>
      <v-container id="billing-sec">
        <v-row>
          <v-col class="Full-Course-Library-Title">
            Account Status : {{ company.state_description }}
          </v-col>
        </v-row>
      </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import companyAPI from "@/api/company.js";
import { EventBus } from "@/event-bus.js";
export default {
  name: "Profile",
  components: {
    LayoutBasic
  },
  data() {
    return {
      company: [],
      params: ""
    };
  },
  computed: {
  },
  mounted() {
    this.getAccountInfo();
    this.setEventBus();
  },
  methods: {
    getAccountInfo() {
      companyAPI.getAccountInfo().then(response => {
        this.company = response.data.data;
      });
    },
    setEventBus() {
      EventBus.$on("COMPANY_UPDATED", () => {
        this.getAccountInfo();
      });
    }
  }
};
</script>
